// extracted by mini-css-extract-plugin
export var checkboxGroup = "style-module--checkbox-group--e5b7a";
export var checkboxInput = "style-module--checkbox-input--2c105";
export var checkboxItem = "style-module--checkbox-item--1d902";
export var label = "style-module--label--b21c4";
export var twoColumns = "style-module--two-columns--f849c";